import { Component, computed, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActionEvent,
  GroupAction,
  StandardAction,
  SwitchActionBuilder,
} from '@infodata-group/inf-commons';
import {
  ActionsBarComponent,
  ActionsBarConfig,
} from '@infodata-group/inf-commons-desktop';

const TOGGLE_ACTION = new SwitchActionBuilder('toggle', 'sliders-h')
  .setIsActive(true)
  .build();

const GROUP_ACTION = new GroupAction('toggle', [TOGGLE_ACTION], 'left');

const ACTION_BAR_CONFIG = ActionsBarConfig.getClassicStyle();
ACTION_BAR_CONFIG.borderMargin = { left: 0, right: 0 };

/**
 * @Deprecated:: Use `ContentWithSlidingLeft` fron `@infodata-group/inf-commons-desktop` instead.
 */
@Component({
  selector: 'infl-page-with-sliding-left',
  imports: [CommonModule, ActionsBarComponent],
  templateUrl: './page-with-sliding-left.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-with-sliding-left.component.scss',
})
export class PageWithSlidingLeftComponent {
  protected readonly config = signal(ACTION_BAR_CONFIG);

  public actions = input<StandardAction[]>([]);

  protected displayedActions = computed(() => {
    return [GROUP_ACTION, ...this.actions()];
  });
  protected isOpen = signal(true);

  public clickAction = output<ActionEvent>();

  protected onActionClickToolbar($event: ActionEvent) {
    if ($event.action.name === 'toggle') {
      this.isOpen.set(!this.isOpen());
    }
    this.clickAction.emit($event);
  }
}
